import Vue from 'vue';
import Router from 'vue-router';

import Dashboard from './views/Dashboard.vue';
//import Monitor from './views/Monitor.vue';
import UserProfile from './views/UserProfile.vue';
import Errors from './views/Errors.vue';
import Login from './views/Login.vue';
//import RegistrantList from './views/RegistrantList.vue';
//import RegistrantForm from './views/Registrant.vue';
//import MessageList from './views/MessageList.vue';
//import MessageForm from './views/Message.vue';
import LocationList from './views/LocationList.vue';
import LocationForm from './views/LocationForm.vue';
//import OrganizationList from './views/OrganizationList.vue';
//import OrganizationForm from './views/OrganizationForm.vue';
//import ScheduleList from './views/ScheduleList.vue';
//import ScheduleForm from './views/ScheduleForm.vue';
import UserList from './views/UserList.vue';
import UserForm from './views/UserForm.vue';
import PersonForm from './views/Person.vue';
import PersonList from './views/PersonList.vue';
import DonatorList from './views/DonatorList.vue';
import DonatorForm from './views/Donator.vue';
import DonationList from './views/DonationList.vue';
import DonationForm from './views/Donation.vue';
import BirthdayList from './views/BirthdayList.vue';
import ChurchList from './views/ChurchList.vue';
import ChurchForm from './views/ChurchForm.vue';
import ReportList from './views/ReportList.vue';
import DonatorReport from './reports/DonatorReport.vue';
import DonationReport from './reports/DonationReport.vue';
import TemplateList from './views/TemplateList.vue';
import BirthdayTemplate from './templates/Birthday.vue';
import ReceiptTemplate from './templates/Receipt.vue';
import store from './store';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL + 'sttaa.admin/',
  linkActiveClass: 'active',
  linkExactActiveClass: 'exact-active',
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/',
      redirect: '/dashboard',
    },
    {
      path: '/login',
      name: 'login',
      meta: { layout: 'login', requiresAuth: false },
      component: Login,
    },
    {
      path: '/user-list',
      name: 'user-list',
      component: UserList,
      meta: { requiresAuth: true },
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      meta: { requiresAuth: true },
      component: Dashboard,
    },
    {
      path: '/errors',
      name: 'errors',
      meta: { requiresAuth: true },
      component: Errors,
    },
    {
      path: '/user-form',
      name: 'user-form',
      meta: { requiresAuth: true },
      component: UserForm,
    },
    {
      path: '/user-profile',
      name: 'user-profile',
      component: UserProfile,
      meta: { requiresAuth: true },
    },
    {
      path: '/person-form',
      name: 'person-form',
      meta: { requiresAuth: true },
      component: PersonForm,
    },
    {
      path: '/person-list',
      name: 'person-list',
      component: PersonList,
      meta: { requiresAuth: true },
    },
    {
      path: '/donator-form',
      name: 'donator-form',
      meta: { requiresAuth: true },
      component: DonatorForm,
    },
    {
      path: '/donator-list',
      name: 'donator-list',
      component: DonatorList,
      meta: { requiresAuth: true },
    },
    {
      path: '/donation-list',
      name: 'donation-list',
      component: DonationList,
      meta: { requiresAuth: true },
    },
    {
      path: '/donation-form',
      name: 'donation-form',
      component: DonationForm,
      meta: { requiresAuth: true },
    },
    {
      path: '/church-list',
      name: 'church-list',
      component: ChurchList,
      meta: { requiresAuth: true },
    },
    {
      path: '/church-form',
      name: 'church-form',
      component: ChurchForm,
      meta: { requiresAuth: true },
    },
    {
      path: '/location-list',
      name: 'location-list',
      component: LocationList,
      meta: { requiresAuth: true },
    },
    {
      path: '/location-form',
      name: 'location-form',
      component: LocationForm,
      meta: { requiresAuth: true },
    },
    {
      path: '/birthday-list',
      name: 'birthday-list',
      component: BirthdayList,
      meta: { requiresAuth: true },
    },
    {
      path: '/report-list',
      name: 'report-list',
      component: ReportList,
      meta: { requiresAuth: true },
    },
    {
      path: '/donator-report',
      name: 'donator-report',
      meta: { requiresAuth: true },
      component: DonatorReport,
    },
    {
      path: '/donation-report',
      name: 'donation-report',
      meta: { requiresAuth: true },
      component: DonationReport,
    },
    {
      path: '/template-list',
      name: 'template-list',
      component: TemplateList,
      meta: { requiresAuth: true },
    },
    {
      path: '/birthday-template',
      name: 'birthday-template',
      meta: { requiresAuth: true },
      component: BirthdayTemplate,
    },
    {
      path: '/receipt-template',
      name: 'receipt-template',
      meta: { requiresAuth: true },
      component: ReceiptTemplate,
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (store.state.token === '' || store.state.token == null) {
      next({
        path: '/login',
        query: { redirect: to.fullPath },
      });
    } else {
      next();
    }
  } else {
    next(); // make sure to always call next()!
  }
});

export default router;
